import React from "react";
import { string } from "prop-types";

import { appleStore, googlePlay } from "../../assets";
import * as S from "./styled";

const MobileAppLinks = ({ platform }) => (
  <S.Wrapper>
    {(platform === "ios" || platform === "") && (
      <S.Link
        ariaLabel="Download on the App Store"
        href="https://app.us.adjust.com/twslzb"
      >
        <S.Icon alt="Download on the App Store" src={appleStore} />
      </S.Link>
    )}
    {(platform === "android" || platform === "") && (
      <S.Link
        ariaLabel="Get it on Google Play"
        href="https://app.us.adjust.com/p2p50p"
      >
        <S.Icon alt="Get it on Google Play" src={googlePlay} />
      </S.Link>
    )}
  </S.Wrapper>
);

MobileAppLinks.propTypes = {
  platform: string
};

MobileAppLinks.defaultProps = {
  platform: ""
};

export default MobileAppLinks;
